import React, { ReactNode } from 'react';

import {
  Header,
  PageContainer,
  PageHeading,
  Sidebar,
} from '@/components/templates/PageLayout';
import { MenuManagementSingleSelectInput } from '@/components/templates/PageLayout/Sidebar/MenuManagementsAccordionItem';
import { CmBox, CmFlex, CmScrollBox } from '@/components/uiParts';
import { useTargetsDomHeight } from '@/hooks/Dom';
import { SIDEBAR_WIDTH } from '@/styles';

export const SIDEBAR_ID = 'sidebar';
export const HEADER_ID = 'header';

interface Props {
  children: ReactNode;
  alert?: ReactNode;
  /** 文字列のほか、一部をリンクにした ReactNode も渡せます。 */
  title: ReactNode;
  className?: string;
  associateBrandSelectInput?: MenuManagementSingleSelectInput;
  disableScroll?: boolean;
}

export const PageLayout: React.FC<Props> = ({
  children,
  alert,
  title,
  className = '',
  associateBrandSelectInput,
  disableScroll = false,
}) => {
  const { targetsHeight } = useTargetsDomHeight([HEADER_ID]);

  return (
    <CmFlex className={className}>
      <CmBox
        position="fixed"
        top={0}
        zIndex={10}
        w={SIDEBAR_WIDTH}
        id={SIDEBAR_ID}
      >
        <Sidebar {...{ associateBrandSelectInput }} />
      </CmBox>
      <CmBox width="100%" ml={SIDEBAR_WIDTH}>
        <CmBox
          position="sticky"
          top={0}
          background="#fff"
          borderBottom="1px solid #718096"
          zIndex={5}
          px={7}
          py={2}
          id={HEADER_ID}
        >
          <CmFlex justifyContent="space-between" alignItems="center">
            {title !== '' && <PageHeading size="lg">{title}</PageHeading>}
            <Header {...{ alert }} />
          </CmFlex>
        </CmBox>
        <PageContainer>
          {disableScroll ? (
            <CmBox pb={0}>{children}</CmBox>
          ) : (
            /** @NOTE サイドバーをスクロールしたときに中央コンテンツまでスクロールをされるため対処。*/
            <CmScrollBox height={`calc(100vh - ${targetsHeight}px)`} pb={0}>
              {children}
            </CmScrollBox>
          )}
        </PageContainer>
      </CmBox>
    </CmFlex>
  );
};
